import { create } from "zustand";

export type ImportSheetTab = "successful" | "failed" | "processing";

interface PipelineUiState {
  importOpen: boolean;
  /**
   * Which tab to activate the next time the ProfileImportSheet opens.
   * The sheet consumes + clears this on open, then falls back to its
   * local default ("successful"). Set it via `openImportSheet` when
   * opening programmatically.
   */
  importInitialTab: ImportSheetTab | null;

  setImportOpen: (open: boolean) => void;
  openImportSheet: (initialTab?: ImportSheetTab) => void;
  consumeImportInitialTab: () => ImportSheetTab | null;
}

export const usePipelineUiStore = create<PipelineUiState>()((set, get) => ({
  importOpen: false,
  importInitialTab: null,

  setImportOpen: (open) => set({ importOpen: open }),

  openImportSheet: (initialTab) =>
    set({ importOpen: true, importInitialTab: initialTab ?? null }),

  consumeImportInitialTab: () => {
    const tab = get().importInitialTab;
    if (tab !== null) set({ importInitialTab: null });
    return tab;
  },
}));
